'use strict';

var _ = require('lodash');
var SeasonalityOverridesService = function SeasonalityOverridesService(seasonalityConstants, momentService) {
  var EXCEEDED_NUMBER_OF_WEEKS = 53;
  var DEFAULT_NUMBER_OF_WEEKS = 52;
  function getYear(visibleData) {
    var year = momentService.now(momentService.FIELD.DEPARTURE_DATE).year();
    switch (visibleData) {
      case seasonalityConstants.REVIEW_SEASONALITY_MODES.CURRENT:
        return year;
      case seasonalityConstants.REVIEW_SEASONALITY_MODES.CURRENT_PLUS:
        return year + 1;
    }
  }
  function normalizeWeekNo(weekNo) {
    return weekNo === 0 || weekNo === EXCEEDED_NUMBER_OF_WEEKS ? DEFAULT_NUMBER_OF_WEEKS : weekNo;
  }
  function filterNormalizedOverrides(item) {
    return normalizeWeekNo(item.weekNo) === DEFAULT_NUMBER_OF_WEEKS;
  }
  function findCurrentYearOverrides(overrides, overrideKey, overrideYear, overrideValue) {
    return _.chain(overrides).filter(overrideKey).filter({
      year: overrideYear,
      weekNo: overrideValue.weekNo
    }).value();
  }
  function findAllYearOverrides(overrides, overrideKey, overrideValue) {
    //all year override for week 52 - we have to delete overrides for week 0 and 53 in that case
    if (overrideValue.weekNo === DEFAULT_NUMBER_OF_WEEKS) {
      return _.chain(overrides).filter(overrideKey).filter(filterNormalizedOverrides).value();
    } else {
      return _.chain(overrides).filter(overrideKey).filter({
        weekNo: overrideValue.weekNo
      }).value();
    }
  }
  function getOverrideKey(calendar, classGroup, dowGroup, spos) {
    var overrideKey = {
      dowGroup: dowGroup || calendar.selectedDow.id || null,
      significantPOS: spos || calendar.spos || null
    };
    if (calendar.seasonalityType === seasonalityConstants.SEASONALITY_TYPE.POOLED) {
      overrideKey.cabin = calendar.cabin;
    } else {
      overrideKey.classGroup = classGroup || calendar.classGroup || null;
    }
    return overrideKey;
  }
  function addOverride(calendar, weekNumber, season, classGroup, dowGroup, spos) {
    var result = _.cloneDeep(calendar.overrides);
    var overrideYear = getYear(calendar.visibleData);
    var existingOverrides;
    var overrideKey = getOverrideKey(calendar, classGroup, dowGroup, spos);
    var overrideValue = {
      marketSpecialEvents: [],
      weekNo: weekNumber,
      year: overrideYear,
      season: season
    };
    if (overrideYear) {
      existingOverrides = findCurrentYearOverrides(result, overrideKey, overrideYear, overrideValue);
    } else {
      existingOverrides = findAllYearOverrides(result, overrideKey, overrideValue);
    }
    _.forEach(existingOverrides, function (override) {
      result = _.reject(result, override);
    });
    var newOverride = _.extend(overrideKey, overrideValue);
    result.push(newOverride);
    return result;
  }
  return {
    addOverride: addOverride
  };
};
SeasonalityOverridesService.$inject = ['SeasonalityConstants', 'MomentService'];
module.exports = SeasonalityOverridesService;